import { getDefaultPanelColors } from './get-default-panel-colors';

export function setDefaultPanelFontHighlight(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty(
    '--panelFontHighlight',
    getDefaultPanelColors().panelFontHighlight,
  );
}
